import { useQuery } from '@tanstack/react-query';
import { previewFlowContacts } from '../../api/flows';
import { useOrganizationStore } from '../../stores/useOrganizationStore';
import type { FlowContactsPreview } from './flowEnrollment';

/**
 * Who adding the selected tags' contacts would actually enroll, and who the
 * consent plan leaves out and why. Read-only; the bulk add plans again at
 * submit, so a consent change in between is still honored.
 */
export const useFlowContactsPreview = (flowId: string, tags: string[], enabled: boolean) => {
  const { organization } = useOrganizationStore();

  const { data, isFetching, isError, refetch } = useQuery<FlowContactsPreview, Error>({
    queryKey: ['flowContacts', 'preview', organization?.id, flowId, tags],
    queryFn: () => previewFlowContacts(flowId, organization!.id, tags),
    enabled: enabled && !!organization?.id && !!flowId && tags.length > 0,
    // Consent can change between searches; an old plan must never gate Add.
    staleTime: 0,
  });

  return { preview: data ?? null, isFetching, isError, refetch };
};
